export default "__VITE_ASSET__SNoK$p29__"